import SelectImpactAssessmentPlanDialog from "./SelectImpactAssessmentPlanDialog";

interface PlanManagementDialogProps {
  readonly open: boolean;
  readonly onClose: () => void;
}

export default function PlanManagementDialog({
  open,
  onClose,
}: PlanManagementDialogProps) {
  return (
    <SelectImpactAssessmentPlanDialog open={open} onClose={onClose} />
  );
}
